import { h, svgUse } from '../utils/dom.js';
import { t } from '../i18n/index.js';
import { toggleTheme } from '../hooks/useTheme.js';
import { toggleLanguage } from '../hooks/useLanguage.js';
import { registerDropdown, toggleDropdown, closeAllDropdowns } from '../hooks/useDropdown.js';
import { initSearch } from '../hooks/useSearch.js';
import { SearchBox } from '../components/features/search/SearchBox.js';
import { LangSwitch } from '../components/features/language/LangSwitch.js';
import { NotificationsMenu } from '../components/features/notifications/NotificationsMenu.js';
import { AvatarMenu } from '../components/features/avatar/AvatarMenu.js';

export function renderHeader(container, { pages, activeTab, onTabChange }) {
  container.innerHTML = '';

  const brand = h('div', { class: 'brand' },
    h('div', { class: 'mark' }, svgUse('ic-door')),
    h('div', { class: 'word' }, h('b', {}, 'LUDUS'), h('span', {}, t('brandTag'))),
  );

  const tabs = h('nav', { class: 'tabs' },
    ...Object.entries(pages).filter(([, cfg]) => cfg.labelKey).map(([key, cfg]) => {
      const btn = h('button', {
        class: key === activeTab ? 'active' : '',
        onclick: () => { closeAllDropdowns(); onTabChange(key); },
      }, svgUse(cfg.icon), h('span', {}, t(cfg.labelKey)));
      return btn;
    })
  );

  const searchBox = SearchBox();
  const searchBtn = h('button', {
    class: 'icon-btn', id: 'searchBtn', 'aria-label': 'search',
    onclick: (e) => { e.stopPropagation(); searchBox.toggle(); }
  }, svgUse('ic-search'));

  const langSwitch = LangSwitch();

  const themeBtn = h('button', { class: 'icon-btn', 'aria-label': 'theme' });
  const updateThemeIcon = () => {
    themeBtn.innerHTML = '';
    const isDarkNow = document.documentElement.getAttribute('data-theme') === 'dark' ||
      (!document.documentElement.getAttribute('data-theme') && window.matchMedia('(prefers-color-scheme: dark)').matches);
    themeBtn.appendChild(svgUse(isDarkNow ? 'ic-sun' : 'ic-moon'));
  };
  updateThemeIcon();
  themeBtn.addEventListener('click', (e) => { e.stopPropagation(); toggleTheme(); updateThemeIcon(); });

  const notifications = NotificationsMenu();
  const avatar = AvatarMenu({ onGoProfile: () => onTabChange('profile') });

  const controls = h('div', { class: 'header-controls' },
    searchBox.el, searchBtn, langSwitch.el, themeBtn, notifications.el, avatar.el,
  );

  const inner = h('div', { class: 'wrap header-inner' }, brand, tabs, controls);
  const header = h('header', {}, inner);
  container.appendChild(header);

  // Wire up the search input focus handler for the trigger button
  initSearch(header);
}
